import React from 'react';
import { LABEL_EVERY_N_DAYS } from '../constants';
import { addDays, parseDate } from '../dateUtils';
import { useGanttContext } from '../GanttContext';

type Props = {
  startDate: string;
};

type DayMeta = {
  iso: string;
  label: string;
  isWeekend: boolean;
};

const buildDays = (startDate: string, nDays: number): DayMeta[] =>
  Array.from({ length: nDays }, (_, i) => {
    const iso = addDays(startDate, i);
    const date = parseDate(iso);
    const dow = date.getDay();
    const isWeekend = dow === 0 || dow === 6;
    const showLabel = i % LABEL_EVERY_N_DAYS === 0;
    const label = showLabel
      ? `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}`
      : '';
    return { iso, label, isWeekend };
  });

export const TimelineHeader: React.FC<Props> = ({ startDate }) => {
  const ctx = useGanttContext();
  const days = buildDays(startDate, ctx.timelineDays);


  return (
    <div
      style={{
        display: 'flex',
        height: 28,
        borderBottom: '1px solid #d0d0d0',
        background: '#fafafa',
        flexShrink: 0,
        userSelect: 'none',
        position: "sticky",
        top: 0,
        zIndex: 500,
      }}
    >
      {days.map(({ iso, label, isWeekend }) => (
        <div
          key={iso}
          style={{
            width: ctx.columnWidth,
            minWidth: ctx.columnWidth,
            height: '100%',
            borderRight: '1px solid #e8e8e8',
            background: isWeekend ? '#f2f2f2' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 3,
            fontSize: 10,
            color: '#999',
            boxSizing: 'border-box',
            flexShrink: 0,
          }}
        >
          {label}
        </div>
      ))}
    </div>
  );
};
